<template>
	<SimpleModal @close="closeModal">
		<div class="error-modal-padding">
			<div class="upload-title font22" v-text="message" />
			<div class="upload-title-2 font15 p-l-r-30">
				{{ error.sub }}
			</div>
			<Button
				link
				pronto
				href="https://support.pronto.io/en/articles/4261934-grant-access-to-microphone-camera-and-screen-recording"
				target="_blank"
			>
				<!-- TODO: This should be localized at some point -->
				Get help enabling your browser for Pronto meetings
			</Button>
		</div>
	</SimpleModal>
</template>

<script>
import { SimpleModal, Button } from '../common'

export default {
	name: 'ErrorModal',
	components: { SimpleModal, Button },
	props: {
		error: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		message() {
			return this.error?.main ?? this.$t('common_api_error')
		},
	},

	emits: ['close'],
	methods: {
		closeModal() {
			this.$emit('close')
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.error-modal-padding {
	padding: 50px;
	@include flex-column;
	align-items: center;
	justify-content: center;
	> .pronto-btn {
		&:hover {
			background: transparent !important;
		}
	}
}
</style>
